import { createPortal } from 'react-dom';
import { useCart } from '../../context/CartContext';
import { API_BASE_URL } from '../../constants';
import { auth } from '../../firebase';
import './Cart.css';

function CartDrawer({ isOpen, onClose }) {
  const { cartItems, cartTotal, removeFromCart, clearCart, currentUser } = useCart();

  const formatPrice = (dollars) => {
    if (!dollars || dollars === 0) return 'Free';
    return `$${Number(dollars).toFixed(2)}`;
  };

  const handleCheckout = async () => {
    if (!currentUser) return;
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(`${API_BASE_URL}/api/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Checkout failed');
      }

      const data = await response.json();

      if (data.free) {
        // All items were free – already granted server-side
        clearCart();
        onClose();
        window.location.href = '/checkout/success?free=1';
      } else {
        // Redirect to Stripe checkout
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Checkout error:', error);
      alert('Failed to start checkout. Please try again.');
    }
  };

  return createPortal(
    <div
      className={`cart-drawer-overlay${isOpen ? ' cart-drawer-overlay--open' : ''}`}
      onClick={onClose}
    >
      <div
        className={`cart-drawer${isOpen ? ' cart-drawer--open' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cart-drawer__header">
          <h2>Shopping Cart</h2>
          <button className="cart-drawer__close" onClick={onClose}>✕</button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-drawer__empty">
            <p>Your cart is empty</p>
          </div>
        ) : (
          <>
            <ul className="cart-drawer__items">
              {cartItems.map((item) => (
                <li key={item.id} className="cart-drawer__item">
                  <div className="cart-drawer__item-image">
                    {item.imageUrl ? (
                      <img src={item.imageUrl} alt={item.name} />
                    ) : (
                      <div className="cart-drawer__item-placeholder">
                        {item.name?.charAt(0).toUpperCase() || 'P'}
                      </div>
                    )}
                  </div>
                  <div className="cart-drawer__item-info">
                    <span className="cart-drawer__item-name">{item.name}</span>
                    <span className="cart-drawer__item-price">{formatPrice(item.price)}</span>
                  </div>
                  <button
                    className="cart-drawer__item-remove"
                    onClick={() => removeFromCart(item.projectId)}
                  >
                    ✕
                  </button>
                </li>
              ))}
            </ul>

            <div className="cart-drawer__footer">
              <div className="cart-drawer__total">
                <span>Total:</span>
                <span>{formatPrice(cartTotal)}</span>
              </div>
              <button className="cart-drawer__checkout-btn" onClick={handleCheckout}>
                Proceed to Checkout
              </button>
              <button className="cart-drawer__clear-btn" onClick={clearCart}>
                Clear Cart
              </button>
            </div>
          </>
        )}
      </div>
    </div>,
    document.body
  );
}

export default CartDrawer;
